import { Injectable, signal, WritableSignal } from '@angular/core';
import { GetClinTrakStudyDataResponse } from '@app/generated-api';
import { BehaviorSubject, Observable, take } from 'rxjs';
import { ClinTrakStudySiteViewModel, CountryRegionCtsmViewModel } from '../../models/clintrak';
import { ClinTrakDataService } from '../../services/clintrak/clintrak-data.service';

@Injectable({
    providedIn: 'root',
})
export class ClinTrakDataStateService {
    constructor(private clinTrakDataService: ClinTrakDataService) {}
    private readonly countries = new BehaviorSubject<CountryRegionCtsmViewModel[]>([]);
    private readonly siteData = new BehaviorSubject<ClinTrakStudySiteViewModel>(null);
    private readonly studyClinTrakData = signal<GetClinTrakStudyDataResponse | null>(null);
    public setCountries(): void {
        this.clinTrakDataService
            .getAllCountries()
            .pipe(take(1))
            .subscribe((res) => {
                return this.countries.next(res);
            });
    }

    public getStudyClinTrakData(): WritableSignal<GetClinTrakStudyDataResponse | null> {
        return this.studyClinTrakData;
    }

    public setStudyClinTrakData(studyClinTrakData: GetClinTrakStudyDataResponse): void {
        return this.studyClinTrakData.set(studyClinTrakData);
    }

    public clearStudyClinTrakData(): void {
        return this.studyClinTrakData.set(null);
    }

    public getCountries(): Observable<CountryRegionCtsmViewModel[]> {
        let currentValue = this.countries.getValue();
        if (currentValue.length == 0) this.setCountries();
        return this.countries.asObservable();
    }

    public setStudySiteData(clinTrakSite: ClinTrakStudySiteViewModel): void {
        return this.siteData.next(clinTrakSite);
    }

    public getStudySiteData(): Observable<ClinTrakStudySiteViewModel> {
        return this.siteData.asObservable();
    }
}
